<template>

    <div>

        <header-kravicka
                @updateProfil="emitUpdateProfil"
                :profil="profil"
        />

        <main>

            <div class="container">

                <div class="row justify-content-center">

                    <div class="col-md-12 col-xl-10">

                        <div class="o-pexesoGame">

                            <div class="m-pexesoGame__header d-flex align-items-center justify-content-between">

                                <h3 class="mb-0">Nájdi rovnaké {{ pexesoNadpis.toLowerCase() }}</h3>

                                <div class="a-pexesoGame__stats">
                                    <span class="pexesoGame__time">Čas:<span>{{ stopWatch }}</span></span>
                                    <span class="pexesoGame__moves">Ťahov:<span>{{ steps }}</span></span>
                                </div>

                            </div>

                            <div
                                v-if="pexesoPocetKariet > 0"
                                class="m-pexesoGame__grid"
                                :class="gridSize"
                            >

                                <template
                                    v-for="(pexesoKarta) in pexesoKarty"
                                >

                                    <div
                                        class="a-pexesoGame__tile"
                                        :class="{'--flipped': pexesoKarta.flipped, '--found': pexesoKarta.found}"
                                        @click="flip(pexesoKarta)"
                                    >

                                        <div class="pexesoGame__tileInner">

                                            <div class="pexesoGame__tileFront">
                                                <img class="img-fluid" src="assets/img/tile.png" alt="">
                                            </div>

                                            <div class="pexesoGame__tileBack">
                                                <img class="img-fluid" :src="'assets/img/pexeso/' + pexesoKarta.src" alt="">
                                            </div>

                                            <div class="--foundOverlay"></div>

                                        </div>

                                    </div>

                                </template>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </main>

        <div class="pexesoFooter --left">

            <button class="btn --primary restartGame" @click="restartGame"><span class="icon"></span></button>

            <router-link
                    class="btn --secondary emdGame"
                    :to="{name: 'pexeso-landing', params: { kravicka_id: $route.params.kravicka_id } }"
            >
                Ukončiť hru
            </router-link>

        </div>

        <div class="pexesoFooter --right d-none d-md-block">

            <router-link
                    class="btn --primary closeGame"
                    :to="{name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id }}"
            >
                <span class="icon"></span>
            </router-link>

        </div>

        <!-- Modal -->
        <b-modal id="modalVyhratePexeso" hide-footer hide-header centered class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modalVyhratePexesoTitle" aria-hidden="true" ref="modalVyhratePexeso">
            <!-- Close -->
            <b-button class="m-modalInfo__close" block @click="$bvModal.hide('modalVyhratePexeso')"><span class="icon"></span></b-button>

            <!-- Content -->
            <div class="modal-body o-modalInfo">

                <div class="m-modalLostPassword__content text-center">

                    <img class="img-fluid mb-3" src="assets/img/winningPexeso.png" alt="">
                    <h2 class="m-modalWinningPexeso__name text-center">Gratulujeme!</h2>
                    <p class="text-center m-modalWinningPexeso__text mb-4">
                        Úspešne si dokončil hru Pexeso.<br> Tvoj čas bol <span>{{ stopWatch }}</span> a zvládol si to na <span>{{ steps }} ťahov</span>.
                    </p>

                    <div class="text-center">

                        <router-link
                                class="btn --primary"
                                :to="{name: 'kravicka', params: { kravicka_id: $route.params.kravicka_id }}"
                        >
                            Ukončiť hru
                        </router-link>

                        <router-link
                                class="btn --secondary --trophy"
                                :to="{ name: 'pexeso-leaders',  params: { kravicka_id: $route.params.kravicka_id } }"
                        >
                            <span class="icon"></span>Tabuľka najlepších
                        </router-link>

                    </div>

                </div>

            </div>
            <!-- .Content -->
        </b-modal>

    </div>

</template>

<script>
    import EventService from '@/services/EventService.js'
    import HeaderKravicka from "../partials/HeaderKravicka.vue"

    export default {
        components: {HeaderKravicka},
        props: [
            'profil',
        ],
        data() {
            return {
                pexesoNadpis: '',
                pexesoPocetKariet: 0,
                pexesoPocetKarietRiadok: 0,
                pexesoPocetKarietStlpec: 0,
                pexesoPocetNesparovanych: 0,

                pexesoStartTime: '',
                gamePlaying: {},
                stopWatch: '00:00.0',
                stopWatchMiliseconds: 0,
                steps: 0,
                runningTimeout: null,

                pexesoKarty: [],
                parna: false,
                disableClick: false,
                pair: false,
                otocena1: {},
                otocena2: {},
                upd: false,
                upd2: false
            }
        },
        mounted() {
            this.toggleBodyClass('addClass', 'pexeso')
            this.toggleBodyClass('addClass', '--game')

            this.getPexesoObtiaznost(this.$route.params.obtiaznost_id)
        },
        updated() {
            if (this.upd && this.upd2) {
                this.upd = false
                console.log('upd')
                this.restartGame()
            }
        },
        destroyed() {
            this.toggleBodyClass('removeClass', 'pexeso')
            this.toggleBodyClass('removeClass', '--game')
        },
        computed: {
            gridSize() {
                return '--grid' + this.pexesoPocetKarietStlpec + 'x' + this.pexesoPocetKarietRiadok
            },
            percentaZabavy() {
                return 50
            }
        },
        methods: {
            getPexesoObtiaznost(id) {
                EventService.getPexesoObtiaznost(id)
                    .then(response => {
                        this.pexesoPocetKarietRiadok = response.data.data.pexeso_obtiaznost_riadkov
                        this.pexesoPocetKarietStlpec = response.data.data.pexeso_obtiaznost_stlpcov
                        this.pexesoPocetKariet =  this.pexesoPocetKarietRiadok * this.pexesoPocetKarietStlpec

                        this.getPexesoMotiv(this.$route.params.motiv_id)
                        this.upd = true
                    })
            },

            getPexesoMotiv(id) {
                EventService.getPexesoMotiv(id)
                    .then(response => {
                        this.pexesoNadpis = response.data.data.pexeso_motiv_nadpis

                        let vsetkyKartyMotivu = JSON.parse(response.data.data.pexeso_motiv_karty)
                        vsetkyKartyMotivu.forEach(this.createPexesoKarty)

                        this.startGame()
                    })
            },

            startGame() {
                this.pexesoKarty = this.shuffle(this.pexesoKarty)
                this.pexesoStartTime = Date.now()
                this.gamePlaying = setInterval(this.updateStopWatch, 100)
                this.pexesoPocetNesparovanych = ( this.pexesoPocetKariet / 2 )
                this.upd2 = true
            },

            restartGame() {
                clearInterval(this.gamePlaying)
                this.steps = 0
                this.pexesoKarty = []
                this.getPexesoMotiv(this.$route.params.motiv_id)
            },

            createPexesoKarty(kartaMotivu, index) {
                if ( index < ( this.pexesoPocetKariet / 2 ) ) {
                    this.pexesoKarty.push(this.createPexesoKarta(kartaMotivu))
                    this.pexesoKarty.push(this.createPexesoKarta(kartaMotivu))
                }
            },

            createPexesoKarta(kartaMotivu) {
                let pexesoKarta = {}
                pexesoKarta.flipped = false
                pexesoKarta.found = false
                pexesoKarta.src = kartaMotivu

                return pexesoKarta
            },

            flip(pexesoKarta) {

                if ( !pexesoKarta.flipped && !pexesoKarta.found ) {

                    if ( !this.pair ) {

                        if ( this.disableClick ) {

                            this.flipBack()
                            clearTimeout(this.runningTimeout)

                        }

                        pexesoKarta.flipped = true

                        if ( !this.parna ) {

                            this.parna = true
                            this.otocena1 = pexesoKarta

                        }
                        else {

                            this.parna = false
                            this.otocena2 = pexesoKarta
                            this.disableClick = true

                            if ( this.checkPair() ) {

                                this.pair = true
                                setTimeout(this.foundPair, 1000)

                            }
                            else {

                                this.runningTimeout = setTimeout(this.flipBack, 2000)

                            }

                        }

                    }

                }

            },

            checkPair() {
                this.steps++
                return this.otocena1.src === this.otocena2.src
            },

            flipBack() {
                this.otocena1.flipped = false
                this.otocena1 = {}
                this.otocena2.flipped = false
                this.otocena2 = {}
                this.disableClick = false
            },

            foundPair() {
                this.otocena1.found = true
                this.otocena1 = {}
                this.otocena2.found = true
                this.otocena2 = {}
                this.pexesoPocetNesparovanych -= 1

                if ( this.pexesoPocetNesparovanych === 0 ) {
                    this.wonGame()
                }

                this.disableClick = false
                this.pair = false
            },

            wonGame() {
                clearInterval(this.gamePlaying)

                EventService.setPexesoResult(
                    this.$route.params.obtiaznost_id,
                    this.$route.params.motiv_id,
                    this.profil.pouzivatel_id.id,
                    this.steps,
                    this.stopWatchMiliseconds
                )
                    .then(response => {
                        // console.log('data saved')
                        // console.log(response)
                    })

                EventService.updateZabava(
                    this.profil.pouzivatel_id.id,
                    this.percentaZabavy
                )
                    .then(response => {
                        // console.log('data saved')
                        // console.log(response)

                        if (this.profil.pouzivatel_id) {
                            var check = parseFloat(this.percentaZabavy)
                            for (var i = 0; i < this.profil.pouzivatel_id.kravicky_pouzivatela.length; i++) {

                                check += parseFloat(this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_zabava)
                                if (check > 100) {
                                    this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_zabava = 100
                                } else {
                                    this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_zabava += parseFloat(this.percentaZabavy)
                                }

                                this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_global = (parseFloat(this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_jedlo) + parseFloat(this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_pitie) + parseFloat(this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_cistota) + parseFloat(this.profil.pouzivatel_id.kravicky_pouzivatela[i].kravicka_param_zabava)) / 4

                            }
                            this.$emit('update:profil', this.profil)
                        }
                    })

                this.$bvModal.show('modalVyhratePexeso')
                this.checkPexesoAchievements()
            },

            checkPexesoAchievements() {
                this.checkAchievementVyhrajPexeso(19)
                this.checkAchievementVyhrajNajtazsiePexeso(12)
                this.checkAchievementVyhrajPexesoDo30Sekund(22)
                this.checkAchievementVyhrajStrednePexesoDo20Tahov(10)
            },

            checkAchievementVyhrajPexeso(achievementId) {
                this.checkGeneralPexesoAchievement(achievementId)
            },

            checkAchievementVyhrajNajtazsiePexeso(achievementId) {
                if ( this.$route.params.obtiaznost_id === 3 ) {
                    this.checkGeneralPexesoAchievement(achievementId)
                }
            },

            checkAchievementVyhrajPexesoDo30Sekund(achievementId) {
                let threshold = Math.floor(this.stopWatchMiliseconds / 1000)

                if ( threshold < 30 ) {
                    this.checkGeneralPexesoAchievement(achievementId)
                }
            },

            checkAchievementVyhrajStrednePexesoDo20Tahov(achievementId) {
                if ( this.$route.params.obtiaznost_id === 2 && this.steps <= 20 ) {
                    this.checkGeneralPexesoAchievement(achievementId)
                }
            },

            checkGeneralPexesoAchievement(achievementId) {
                var key = EventService.checkAchievementProgress(this.profil, achievementId)
                if (key > -2) {
                    EventService.setAchievementProgress(this.profil, achievementId)
                        .then(response => {
                            //console.log(response.data)
                            //this.responseType = response.data.code
                            //this.responseText = response.data.data

                            sessionStorage.setItem("album-uspechy", "refresh")

                            if (key == -1) {
                                this.$emit('updateProfil')
                            } else {
                                this.profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current += 1
                                this.$emit('update:profil', this.profil)
                            }

                            // achievements toast popup
                            this.$toast.success(' ', response.data.data)
                        })
                        .catch(error => {
                            //console.log('There was an error:', error.response.data.error)
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },

            shuffle(array) {
                var currentIndex = array.length, temporaryValue, randomIndex

                // While there remain elements to shuffle...
                while (0 !== currentIndex) {

                    // Pick a remaining element...
                    randomIndex = Math.floor(Math.random() * currentIndex)
                    currentIndex -= 1

                    // And swap it with the current element.
                    temporaryValue = array[currentIndex]
                    array[currentIndex] = array[randomIndex]
                    array[randomIndex] = temporaryValue
                }

                return array;
            },

            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            emitUpdateProfil() {
                this.$emit('updateProfil')
            },

            updateStopWatch() {
                var miliseconds = Date.now() - this.pexesoStartTime
                this.stopWatchMiliseconds = miliseconds

                let hours = Math.floor(miliseconds / 1000 / 60 / 60)
                miliseconds -= hours * 1000 * 60 * 60

                let minutes = Math.floor(miliseconds / 1000 / 60)
                miliseconds -= minutes * 1000 * 60

                let seconds = Math.floor(miliseconds / 1000)
                miliseconds -= seconds * 1000

                let tenths = Math.floor(miliseconds / 100)

                this.stopWatch = this.formatTime(minutes) + ':' + this.formatTime(seconds) + '.' + tenths
            },

            formatTime(timeInt) {
                return ('0'  + timeInt).slice(-2)
            },
        }
    }

</script>